import React, { useState } from 'react';
import './ConfirmModal.scss';

const ConfirmationCodeModal = ({ closeModal,
                                 onClose,
                                 onOk,
                                 t,
                                 okButtonName=null,
                                 okButtonText='Ok',
                                 cancelButtonName = null,
                                 cancelButtonText = 'Cancel',
                               }) => {
  const [confCode, setConfCode] = useState(null);

  const onSetConfirmationCode = () => {
    onOk({code: confCode});
    closeModal();
  };

  return (
    <div className='confirmation-code-modal-content'>
      <div className="confirmation-code-modal-body">
        <div className="confirmation-modal-header">
          { t('confirmation_code.dialog.title') }
        </div>
        <div className="confirmation-code-modal-inputs" >
          <label form={'confCode'}>
            Conf Code
          </label>
          <input
            type={'text'}
            name={'confCode'}
            value={ confCode }
            placeholder={ t('confirmation_code.dialog.code_placeholder') }
            onChange={ (e)=>{
              const { value } = e.currentTarget;
              setConfCode(value);
            }}
          />
        </div>
        <div className="confirmation-modal-buttons">
          <button
            name={cancelButtonName}
            className="btn btn-close-modal blue-btn"
            onClick={() => {
              onClose();
              closeModal();
            }
            }
          >
            {cancelButtonText}
          </button>
          <button
            name={okButtonName}
            className="btn btn-close-modal red-btn"
            disabled={ !confCode }
            onClick={ onSetConfirmationCode }
          >
            {okButtonText}
          </button>          
        </div>
      </div>
    </div>
  );
};

export default ConfirmationCodeModal;
